

const {createAuthSystem} = require('./authSystem');
const {createOpenItemSystem} = require('./openItemSystem');
const {createSendMessageSystem} = require('./sendMessageSystem');
const {createSelectStateSystem} = require('./selectStateSystem');
const {createReceiveMessageSystem} = require('./receiveMessageSystem');
const {createAddItemSystem}= require('./addItemSystem');
const {createPingSystem} = require('./pingSystem');

exports.createSearchPanelController = ({
    $scope,
    soundsets,
})=>{

    const sendMessageSystem = createSendMessageSystem()
    const authSystem = createAuthSystem({$scope,sendMessageSystem})
    const openItemSystem = createOpenItemSystem({$scope,soundsets})
    const pingSystem = createPingSystem({sendMessageSystem})
    const selectStateSystem = createSelectStateSystem({$scope,sendMessageSystem})
    const addItemSystem = createAddItemSystem({$scope})
    const receiveMessageSystem = createReceiveMessageSystem({
        pingSystem,
        addItemSystem,
        authSystem,
        openItemSystem,
        selectStateSystem
    })

    return {
        pingSystem,
        sendMessageSystem,
        authSystem,
        openItemSystem,
        selectStateSystem,
        addItemSystem,
        receiveMessageSystem
    }
}



// WEBPACK FOOTER //
// ./djangosite/master/frontend/src/search-panel/index.js